export default __webpack_public_path__ + "static/media/icon-brand-similarity-mapping.b42c5e0f.svg";